<template>
  <div class="mb-8 relative">
    <div class="relative">
      <label v-if="hasLabel" class="font-medium block" :for="id"
             :class="{'pr-6': hasTooltip, 'opacity-50': formDisabled}">
        {{ field.templateOptions.label }}
      </label>

      <div class="absolute right-0 top-0" v-if="hasTooltip">
        <button type="button" class="focus:outline-none focus:shadow-outline rounded-full" @click="isTooltipOpen = true">
          <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9 15h2V9H9v6zm1-15C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM9 7h2V5H9v2z"
                  fill="#110F24" fill-opacity=".4"></path>
          </svg>
          <span class="sr-only">More Information</span>
        </button>
        <div v-if="isTooltipOpen">
          <div @click="isTooltipOpen = false" class="z-10 fixed inset-0"></div>
          <div
            class="z-20 absolute right-0 w-64 text-white text-sm bg-gray-900 bg-opacity-100 py-2 px-3 rounded transition ease-out duration-700">
            <p v-html="tooltipMessage"></p>
          </div>
        </div>
      </div>

    </div>
    <slot></slot>
    <div v-if="hasError" class="text-sm text-red-700">
      <p>{{ errorMessage }}</p>
    </div>
    <div v-if="hasDescription" class="text-sm mt-1">
      <p v-html="sanitizedDescription"></p>
    </div>
  </div>
</template>

<script>
import DOMPurify from "./dom-sanitiser";

export default {
  name: "FieldWrapper",
  props: ["field", "id", "hasError", "errorMessage"],
  data() {
    return {
      isTooltipOpen: false,
    };
  },
  computed: {
    formDisabled() {
      return this.$store.state.formDisabled;
    },
    hasTooltip() {
      if (!this.field.templateOptions) {
        return false;
      }
      return !!this.field.templateOptions.tooltip;
    },
    tooltipMessage() {
      if (!this.field.templateOptions) {
        return "";
      }
      if (!this.field.templateOptions.tooltip) {
        return "";
      }
      return DOMPurify.sanitize(this.field.templateOptions.tooltip, {
        ALLOWED_TAGS: ["b", "a", "br"]
      });
    },
    hasLabel() {
      if (!this.field.templateOptions) {
        return false;
      }
      return !!this.field.templateOptions.label;
    },
    hasDescription() {
      if (!this.field.templateOptions) {
        return false;
      }
      return !!this.field.templateOptions.description;
    },
    sanitizedDescription() {
      if (!this.field.templateOptions) {
        return "";
      }
      if (!this.field.templateOptions.description) {
        return "";
      }
      return DOMPurify.sanitize(this.field.templateOptions.description, {
        ALLOWED_TAGS: ["b", "a", "br"]
      });
    }
  }
};
</script>
